export const isRequiredValidation = value => (!value ? 'Required' : undefined);
export const areValuesTheSame = (value1, value2) =>
  value1 !== value2 ? 'Password and confirmation are not the same' : undefined;

export const isEmail = value => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !re.test(String(value).toLowerCase()) ? 'Not email' : undefined;
};
